import { ApiProperty } from '@nestjs/swagger'
import { IsArray, IsUUID, ArrayMinSize } from 'class-validator'

export class AddLessonConceptsDto {
  @ApiProperty({
    description: 'IDs des concepts du programme à associer à la leçon',
    type: [String],
    example: ['550e8400-e29b-41d4-a716-446655440000'],
  })
  @IsArray()
  @ArrayMinSize(1, { message: 'Au moins un concept doit être spécifié' })
  @IsUUID('4', { each: true })
  programConceptIds!: string[]
}